import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { loaderItems } from "../../../../../../../shared/src/lib/utils/common";

@Component({
  selector: "app-report-loader",
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./report-loader.component.html",
  styleUrl: "./report-loader.component.scss",
})
export class ReportLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly loaderItems = loaderItems;
}
